import type { ReactNode } from 'react'
import { VariantProps, cva } from 'class-variance-authority'
import { DialogTitle } from '@headlessui/react'

import Text from 'components/ui/text'
import { cn } from 'utils/classMerge'

const titleStyles = cva('tw-flex tw-gap-4', {
  variants: {
    orientation: {
      left: 'tw-flex-col tw-items-center tw-text-center sm:tw-flex-row sm:tw-justify-start sm:tw-text-left',
      center: 'tw-flex-col tw-items-center tw-text-center',
    },
  },
  defaultVariants: {
    orientation: 'center',
  },
})
interface ModalTitleProps extends VariantProps<typeof titleStyles> {
  text: string
  customTextStyle?: string
  icon?: ReactNode
  titleVariables?: string[]
  image?: string
}

export default function ModalTitle({
  text,
  customTextStyle,
  icon,
  orientation,
  titleVariables = [],
  image,
}: ModalTitleProps) {
  return (
    <div className={titleStyles({ orientation })}>
      {icon && icon}
      {image && orientation === 'center' && (
        <img className="tw-max-w-full" src={image} alt="modal title" />
      )}

      <DialogTitle as="h1" className="tw-m-0">
        <Text
          className={cn(
            customTextStyle,
            'tw-m-0 tw-text-2xl tw-font-bold tw-text-zinc-950',
          )}
          boldClassName="tw-font-bold"
          translationVariables={titleVariables}
        >
          {text}
        </Text>
      </DialogTitle>
    </div>
  )
}
